// extracted by mini-css-extract-plugin
module.exports = {"container":"sessionCreate_container__3VH1N","sessionHeader":"sessionCreate_sessionHeader__UaC8w","icon":"sessionCreate_icon__s8mOY"};